import React, { useLayoutEffect, useRef, useEffect, useState } from "react";
import { Box, Stack, Typography, Avatar, TextField, IconButton } from "@mui/material";
import altProfile from "../../assets/images/altProfile.png";
import sendIcon from '../../assets/icons/sendicon.svg';
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { makeGetRequestToUrl } from "../commonFunc";
import config from "../../config/config";
dayjs.extend(utc);



const ChatService = ({ messages, user, driver, searchicon, messageText, setMessageText, sendMessage, isExporting, chatId, chatContext }) => {
  const path = useLocation();
  const utcOffset = Number(localStorage.getItem("utc_offset")) || 0;
  const pathName = path.pathname.startsWith('/') ? path.pathname.substring(1) : path.pathname;
  const chatref = useRef(null);
  const prevMsgCountRef = useRef(0);
  const isFirstLoadRef = useRef(true);
  const [chatSuggestion, setChatSuggestion] = useState([]);

  useEffect(() => {
    isFirstLoadRef.current = true;
    prevMsgCountRef.current = 0;
  }, [chatId]);

  const formatTimeWithOffset = (timestamp) => {
    if (!timestamp) return "--";

    return dayjs
      .utc(timestamp)
      .add(utcOffset, "minute")
      .format("hh:mm a");
  };

  const fetchchatSuggestion = async() =>{
    try {
      const url = config.serverUrl + "/panel/fetch_chat_suggestions";
      const payload = {
        token: localStorage.getItem("token"),
        user_type: chatContext=="ADMIN_USER"?1:2,
        is_admin:1,
        timestamp: new Date().getTime()
      }
      const response = await makeGetRequestToUrl(url,payload);
      if(response.flag==200){
        setChatSuggestion(response.data.filter(i=>i.is_active==1));
      }
    } catch (error) {
      
    }
  }

  useEffect(() => {
    fetchchatSuggestion();
  }, []);



  useLayoutEffect(() => {
    const container = chatref.current;
    if (!container) return;

    const currentCount = messages?.length || 0;
    const prevCount = prevMsgCountRef.current;

    const scrollToBottom = () => {
      container.scrollTop = container.scrollHeight;
    };

    // ✅ CASE 1: Card / chat changed → always scroll
    if (isFirstLoadRef.current) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToBottom();
          isFirstLoadRef.current = false;
        });
      });
    }

    // ✅ CASE 2: New message → scroll only if user near bottom
    else if (currentCount > prevCount) {
      const isNearBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight < 120;

      if (isNearBottom) {
        requestAnimationFrame(scrollToBottom);
      }
    }

    prevMsgCountRef.current = currentCount;
  }, [messages]);


  const isLeftMessage = (msg) => {
    switch (chatContext) {

      // Admin ↔ Customer
      case "ADMIN_USER":
        return msg.sender_type === 1; // customer left

      // Admin ↔ Driver
      case "ADMIN_DRIVER":
        return msg.sender_type === 2; // driver left

      // Driver ↔ Customer (admin viewing only)
      case "DRIVER_USER":
        return msg.sender_type === 1; // customer left

      default:
        return true;
    }
  };



  const groupByDate = (msgs) => {
    const groups = {};

    msgs?.forEach((msg) => {
      const dateKey = dayjs
      .utc(msg.created_at)
      .add(utcOffset, "minute")
        .format("YYYY-MM-DD");

      if (!groups[dateKey]) groups[dateKey] = [];
      groups[dateKey].push(msg);
    });

    return groups;
  };

  const grouped = groupByDate(messages);

  return (
    <Box
      sx={{
        height: isExporting
          ? "auto"
          : pathName === "support-chat"
            ? "65vh"
            : "72vh",
        backgroundColor: "#fff",
        borderRadius: "10px",
      }}
    >

      <Box
        ref={chatref}
        sx={{
          overflowY: isExporting ? "visible" : "auto",
          padding: 2,
          height: isExporting
            ? "auto"
            : pathName === "support-chat"
              ? "49vh"
              : "70vh",
          backgroundColor: "#fff",
          borderRadius: "10px",
        }}
      >

        {Object.keys(grouped).map((date) => (
          <Box key={date} sx={{ marginBottom: 3 }}>
            {/* Date Separator */}
            <Box
              sx={{
                textAlign: "center",
                marginY: 2,
              }}
            >
              <Typography
                sx={{
                  display: "inline-block",
                  padding: "2px 12px",
                  background: "#f5f5f5",
                  borderRadius: "20px",
                  fontSize: "13px",
                  color: "#333",
                  fontWeight: 600,
                }}
              >
                {date === new Date().toDateString() ? "Today" : date}
              </Typography>
            </Box>

            {/* Chat Messages */}
            {grouped[date].map((msg) => {

              const isLeft = isLeftMessage(msg);

              const sender =
                msg.sender_type === 1
                  ? { name: user?.user_name, image: user?.user_image }
                  : msg.sender_type === 2
                    ? { name: driver?.driver_name, image: driver?.driver_image }
                    : { name: "Admin", image: altProfile };



              return (
                <Stack
                  key={msg.message_id}
                  direction="row"
                  justifyContent={isLeft ? "flex-start" : "flex-end"}
                  sx={{ marginBottom: "10px" }}
                >
                  {/* Left user message */}

                  <Box>
                    <Box
                      sx={{
                        maxWidth: "100%",
                        padding: "12px 16px",
                        background: isLeft ? "#f7f7f7" : "#2667ff",
                        color: isLeft ? "#000" : "#fff",
                        borderRadius: "18px",
                        borderBottomLeftRadius: isLeft ? "4px" : "18px",
                        borderBottomRightRadius: isLeft ? "18px" : "4px",
                        fontSize: "14px",
                      }}
                    >
                      {msg.message}
                    </Box>

                    {/* Name + time */}
                    {/* <Stack
                      direction="row"
                      sx={{
                        marginTop: "4px",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >

                      {isLeft ? (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>

                            <Avatar
                              src={user?.user_image || altProfile}
                              sx={{
                                width: 16,
                                height: 16,
                                marginRight: 0.5,
                              }}
                            />
                            <Typography
                              sx={{ fontSize: "12px", color: "#666" }}
                            >
                              {user?.user_name}
                            </Typography>
                          </Box>
                          <Typography
                            sx={{ fontSize: "12px", color: "#0065FF" }}
                          >
                            {new Date(msg.created_at).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            sx={{ fontSize: "12px", color: "#0065FF" }}
                          >
                            {new Date(msg.created_at).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', }}>
                            <Avatar
                              src={driver?.driver_image || altProfile}
                              sx={{
                                width: 16,
                                height: 16,
                                mr: 0.5
                              }}
                            />
                            <Typography
                              sx={{ fontSize: "12px", color: "#666" }}
                            >
                              {driver?.driver_name}
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Stack> */}
                    <Stack
                      direction="row"
                      sx={{
                        marginTop: "4px",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {isLeft ? (
                        <>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Avatar
                              src={sender.image || altProfile}
                              sx={{ width: 16, height: 16, mr: 0.5 }}
                            />
                            <Typography sx={{ fontSize: "12px", color: "#666" }}>
                              {sender.name}
                            </Typography>
                          </Box>

                          <Typography sx={{ fontSize: "12px", color: "#0065FF" }}>
                            {formatTimeWithOffset(msg.created_at)}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography sx={{ fontSize: "12px", color: "#0065FF" }}>
                            {formatTimeWithOffset(msg.created_at)}
                          </Typography>

                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Avatar
                              src={sender.image || altProfile}
                              sx={{ width: 16, height: 16, mr: 0.5 }}
                            />
                            <Typography sx={{ fontSize: "12px", color: "#666" }}>
                              {/* {sender.name} */}
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Stack>

                  </Box>

                  {/* Right driver avatar */}
                  {!isLeft && (
                    <Avatar
                      src={driver?.driver_image || altProfile}
                      sx={{
                        width: 16,
                        height: 16,
                        marginLeft: 1,
                        display: "none", // Hide duplicate avatar since we added inline right side avatar
                      }}
                    />
                  )}
                </Stack>
              );
            })}
          </Box>
        ))}
      </Box>

      {searchicon && !isExporting && (
        <>
       {chatSuggestion?.length > 0 && !isExporting && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            px: 1,
            pt: 0.5, 
            borderTop:"1px solid #f0f0f0",
          }}
        >
          {chatSuggestion.map((item) => (
            <Box
              key={item.suggestion_id}
              onClick={() => setMessageText(item.suggestion)}
              sx={{
                px: 2,
                py: 0.8,
                borderRadius: "8px",
                border: "1px solid #96c0ff",
                color: "#434343",
                fontSize: "13px",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "all 0.2s",
                backgroundColor: "#F3F8FF",
                "&:hover": {
                  backgroundColor: "#2667ff",
                  color: "#fff",
                },
              }}
            >
              {item.suggestion}
            </Box>
          ))}
        </Box>
      )}
        <Box
        sx={{
          pb: 0.5,
          px: 1,
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
        >
          
          <TextField
            fullWidth
            placeholder="Type your message..."
            size="small"
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "30px",
              },
            }}
            />
          <IconButton
            color="primary"
            onClick={sendMessage}
            disabled={!messageText?.trim()}
            >
            <img src={sendIcon} alt="send" />
          </IconButton>
        </Box>
        </>
      )}

    </Box>
  );
}


export default ChatService;
